import { DateTime } from 'ts-luxon';

import { LicenseV4 } from '@shure/cloud/shared/models/devices';

import { DeviceLicenseV4Fragment } from '../graphql/generated/cloud-sys-api';

import { mapLicenseStateFromSysApi } from './map-license-state';
import { mapLicenseSystemCommunicationStateV2 } from './map-license-system-communication-state';

export function mapLicenseV4FromSysApi(license: DeviceLicenseV4Fragment | null | undefined): LicenseV4 | undefined {
	if (!license) {
		return undefined;
	}

	return {
		leases: license.leases.map((license) => ({
			count: license.count,
			expirationDate: license.endDate ? DateTime.fromISO(license.endDate) : undefined,
			featureName: license.featureName ?? undefined,
			perpetual: !license.endDate,
			state: mapLicenseStateFromSysApi(license.status)
		})),
		systemStatus: {
			communicationState: mapLicenseSystemCommunicationStateV2(license.systemStatus.communication.state),
			ownershipMatch: license.systemStatus.ownershipMatch
		}
	};
}
